<h2 mat-dialog-title data-test="dialog">{{ data.title }}</h2>
<div mat-dialog-content>
  <agr-form [formGroup]="formGroup">
    <div class="spacing--margin-vertical">
      <agr-extended-notification
        notificationType="info"
        [title]="'reference-value-sheet.overview.upload-csv-notification' | translate"
        [message]="'reference-value-sheet.overview.upload-csv-message' | translate"
      ></agr-extended-notification>
    </div>
    <div class="spacing--margin-vertical">
      <button type="button" mat-stroked-button (click)="file.click()" data-test="file-button">
        {{
          selectedFile
            ? selectedFile.name
            : ('reference-value-sheet.overview.select-file' | translate)
        }}
      </button>
    </div>
    <input
      hidden
      (change)="onFileSelected()"
      #file
      type="file"
      accept=".csv"
      data-test="file-input"
    />
  </agr-form>
</div>
<div mat-dialog-actions data-test="dialogButtons">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedFile"
    (click)="confirm({ file: selectedFile })"
    data-test="dialog-submit"
  >
    {{ data.confirmButtonText }}
  </button>
  <button mat-stroked-button data-test="dialog-cancel" (click)="cancel()">
    {{ data.cancelButtonText }}
  </button>
</div>
